import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import PageDescriptionFootnote from '../../PageDescription/Footnote';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import CorpoTrabalheConosco from '../../Postagens/Noticias/CorpoNoticia/CorpoTrabalheConosco';


class TrabalheConosco extends Component {

	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<ErrorBoundary><BannerSingle page={"trabalhe-conosco"} image={"trabalhe-conosco"} /></ErrorBoundary>
				<div className="page-description mb-9">
					<div className="container">
						<div className="row justify-content-center">
							<div className="col-lg-10">
								<div className="page-description__desc mb-7 mb-lg-9">
									<div className="d-md-flex justify-content-between align-items-center">
										<div className="tittle">
											<h3 className="mb-4 mb-md-0"> Vagas </h3>
											<p className="d-md-none">
												Você pode visualizar todas as oportunidades abertas diretamente em nossa página no kenoby.
											</p>
										</div>
										<a rel="noreferrer" href="https://jobs.kenoby.com/forluz" target="_blank" className="btn btn-primary py-4 px-7 my-7 my-md-0 rounded d-flex align-items-center">
											<span className="ico mr-3">
												<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M5.44444 0V1.55556H1.55556V12.4444H12.4444V8.55556H14V13.2222C14 13.4285 13.9181 13.6263 13.7722 13.7722C13.6263 13.9181 13.4285 14 13.2222 14H0.777778C0.571498 14 0.373667 13.9181 0.227806 13.7722C0.0819442 13.6263 0 13.4285 0 13.2222V0.777778C0 0.571498 0.0819442 0.373667 0.227806 0.227806C0.373667 0.0819442 0.571498 0 0.777778 0H5.44444ZM11.3447 1.55556H7.77778V0H14V6.22222H12.4444V2.65533L7 8.09978L5.90022 7L11.3447 1.55556Z" fill="white" />
												</svg>
											</span>
											<span>
												Ver vagas
											</span>
										</a>
									</div>
								</div>

								<div className="page-description__midias">
									<PageDescriptionFootnote />
								</div>
							</div>
						</div>
					</div>
				</div>
				<ErrorBoundary><CorpoTrabalheConosco /></ErrorBoundary>
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default TrabalheConosco;